module.exports = "/_next/static/images/0b02fea049ccfdfc8852c05dde1154f2-fastcompany.png";